export enum AnalyticsSource {
  MoreMenu = 'More Menu',
  WorkoutControl = 'Workout Control Landing',
}
